module.exports = __webpack_public_path__ + "static/media/girl.57413907.png";